import React, { useContext, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import styles from "./BookingTextsModal.module.css";

type BookingTextsModalProps = {
    onClickBookingText: (bookingText: string) => () => void;
};

const BookingTextsModalBase = (props: BookingTextsModalProps) => {
    const { onClickBookingText } = props;

    const { t } = useTranslation();
    const { accountingBookingTextStore } = useContext(RootStoreContext);

    const toggleDisplayModal = useCallback(() => {
        accountingBookingTextStore.setIsBookingTextsOfAccountModalDisplayed(
            !accountingBookingTextStore.isBookingTextsOfAccountModalDisplayed
        );
    }, [accountingBookingTextStore]);

    const onChangeQueryInput = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            accountingBookingTextStore.setBookingTextOfAccountsModalSearchQuery(event.target.value);
        },
        [accountingBookingTextStore]
    );

    const onClickBookingTextItem = useCallback(
        (bookingText: string) => () => {
            const functionSettingBookingText = onClickBookingText(bookingText);
            functionSettingBookingText();
            toggleDisplayModal();
        },
        [onClickBookingText, toggleDisplayModal]
    );

    return (
        <UI.Modal
            title={t("screens.kredi_flow.accountings.booking_text_modal.title").toString()}
            size="lg"
            show={accountingBookingTextStore.isBookingTextsOfAccountModalDisplayed}
            onClose={toggleDisplayModal}
            centered={true}
            backdrop="static"
            isScrollable={true}
        >
            <UI.Row className={"mt-2"}>
                <UI.Col sm={12}>
                    <div className={"d-flex"}>
                        <div className="mr-2 w-100">
                            <UI.Input
                                type="search"
                                onChange={onChangeQueryInput}
                                placeholder={t("labels.search").toString()}
                                value={accountingBookingTextStore.bookingTextOfAccountsModalSearchQuery}
                            ></UI.Input>
                        </div>
                    </div>
                    <div className={`${styles.ListHeader} d-flex align-items-center`}>
                        <div style={{ flex: 0.5 }}>{t("labels.text")}</div>
                        <div style={{ flex: 0.5, marginLeft: "10px" }}>{t("screens.kredi_flow.list.creditor")}</div>
                    </div>
                    {accountingBookingTextStore.isLoadingAccountingsHistoryByAccountNumber ? (
                        <UI.RotatingSpinner noLogo={true} size={25} />
                    ) : (
                        <div>
                            {accountingBookingTextStore.filteredAccountingsHistoryByAccountNumberData?.map(
                                (historyEntry, index) => {
                                    return (
                                        <div
                                            key={`history-entry-${index}`}
                                            className={`${styles.ListItem} d-flex`}
                                            // onClick={onClickBookingText(historyEntry.text)}
                                            onClick={onClickBookingTextItem(historyEntry.text)}
                                        >
                                            <div style={{ flex: 0.5 }}>{historyEntry.text}</div>
                                            <div style={{ flex: 0.5, marginLeft: "10px" }}>
                                                {historyEntry.creditorName}
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    )}
                </UI.Col>
            </UI.Row>
        </UI.Modal>
    );
};

export const BookingTextsModal = Sentry.withProfiler(observer(BookingTextsModalBase));
